import { localStorageHelper } from "../hooks/localStorageHelper";
import { GroupAdmin, PROFILE_KEY, Roles } from "./Constants";

export const getYearDiffWithMonth = (startDate: Date, endDate: Date) => {
  const ms = endDate.getTime() - startDate.getTime();

  const date = new Date(ms);
  return Math.abs(date.getUTCFullYear() - 1970);
};

export const parseJwt = (token) => {
  var base64Url = token.split(".")[1];
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  var jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );

  return JSON.parse(jsonPayload);
};

const getRolesFromToken = (): string[] => {
  try {
    const token = localStorageHelper.load(PROFILE_KEY)?.access_token;
    if (!token) return [];
    return parseJwt(token)?.resource_access?.["qf-connect-api"]?.roles ?? [];
  } catch (error) {
    console.error("Error decoding roles from token:", error);
    return [];
  }
};

const getGroupsFromToken = (): string[] => {
  try {
    const token = localStorageHelper.load(PROFILE_KEY)?.access_token;
    if (!token) return [];
    return parseJwt(token)?.groups ?? [];
  } catch (error) {
    console.error("Error decoding groups from token:", error);
    return [];
  }
};

export const hasRole = (roleName: Roles): boolean => {
    const roles = getRolesFromToken();
  return roles.includes(roleName);
};

/**
 * Returns true if the user has any of the roles passed in the array
 * @param roleNames - list of roles to check
 * @returns
 */
export const hasAnyRole = (roleNames: Roles[]): boolean => {
  const roles = getRolesFromToken();
  return roleNames.some((role) => roles.includes(role));
};

export const hasGroupAdminRole = (roleName: GroupAdmin): boolean => {
  return getGroupsFromToken().includes(roleName);
};

export const hasAnyGroupAdminRole = (roleNames: GroupAdmin[]): boolean => {
  const groups = getGroupsFromToken();
  return roleNames.some((role) => groups.includes(role));
};
